import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { BannerService, IBanner } from '../../services/banner.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.scss'],
})
export class HomeBannerComponent implements OnInit, OnDestroy {
  banners: IBanner[] = [];
  currentIndex = 0;
  private autoPlayInterval: ReturnType<typeof setInterval> | null = null;
  private languageSub?: Subscription;

  constructor(
    private readonly bannerService: BannerService,
    private readonly languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.languageSub = this.languageService.currentLanguage$.subscribe(() => {
      this.loadBanners();
    });
  }

  ngOnDestroy(): void {
    this.languageSub?.unsubscribe();
    this.stopAutoPlay();
  }

  get currentBanner(): IBanner | null {
    return this.banners[this.currentIndex] ?? null;
  }

  goTo(index: number): void {
    this.currentIndex = index;
    this.stopAutoPlay();
    if (this.banners.length > 1) {
      this.startAutoPlay();
    }
  }

  private loadBanners(): void {
    this.stopAutoPlay();
    this.bannerService.getActiveBanners().subscribe({
      next: (banners) => {
        this.banners = banners;
        this.currentIndex = 0;
        if (this.banners.length > 1) {
          this.startAutoPlay();
        }
      },
      error: () => {
        this.banners = [];
        this.currentIndex = 0;
      },
    });
  }

  private startAutoPlay(): void {
    this.autoPlayInterval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.banners.length;
    }, 5000);
  }

  private stopAutoPlay(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}
